// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__11ysM","content":"Consent_content__1xmD7","footer":"Consent_footer__3zFy6"};